/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_OriginalInputs */

const en_stats_original = /** @type {(inputs: Stats_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const ko_stats_original = /** @type {(inputs: Stats_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원본`)
};

const ja_stats_original = /** @type {(inputs: Stats_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元のサイズ`)
};

/**
* | output |
* | --- |
* | "Original" |
*
* @param {Stats_OriginalInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const stats_original = /** @type {((inputs?: Stats_OriginalInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_OriginalInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stats_original(inputs)
	if (locale === "ko") return ko_stats_original(inputs)
	return ja_stats_original(inputs)
});